import { PC_CONSOLE_COMBINE_ENTITY_TYPE, } from '@intelligence/pages/TopCharts/_config/topChartsConst';
const SPECIAL_VGINSIGHTS_METRICS = ['pcu', 'acu'];

const PUBLISHER_CLASS_I18N_KEY_MAP: Record<string, string> = {
  Hobbyist: 'dbi_publisher_class_hobbyist',
  Indie: 'dbi_publisher_class_indie',
  AA: 'dbi_publisher_class_aa',
  AAA: 'dbi_publisher_class_aaa',
};

/**
 * CombileMetricsTable页面是把pcu、acu指标 判定为 vginsights数据源的（主要是为了UI展示上，展示vginsights数据源对应的icon），但是服务端是把pcu、acu指标判定为steamcharts数据源的
 * 所以在给服务端入参时，需要对pcu，acu指标的数据源进行特殊处理为steamcharts数据源
 * @param dataSource 数据源
 * @param metric 指标
 * @returns 指标对应的数据源（给服务端用）
 */
export const getServerDataSourceOfCombineMetricsTable = (dataSource: string, metric: string): string => {
  if (SPECIAL_VGINSIGHTS_METRICS?.includes(metric)) return 'steamcharts';
  return dataSource;
};

/**
 * CombileMetricsTable页面是把pcu、acu指标 判定为 vginsights数据源的（主要是为了UI展示上，展示vginsights数据源对应的icon），但是服务端是把pcu、acu指标判定为steamcharts数据源的
 * 所以在给服务端入参时，需要对pcu，acu指标的数据源进行特殊处理为steamcharts数据源
 * @param dataSource 数据源
 * @param metric 指标
 * @returns 指标对应的数据源（给前端用）
 */
export const getClientDataSourceOfCombineMetricsTable = (dataSource: string, metric: string, entityType: string): string => {
  //表格高亮，如果是融合ID，则特殊处理pcu，acu指标
  if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE && SPECIAL_VGINSIGHTS_METRICS?.includes(metric)) return 'vginsights';
  if (dataSource === 'newzoo_weight') return 'newzoo';
  return dataSource;
};

export const getPublisherClassText = (value: string, formatMessage: (descriptor: { id: string }) => string) => {
  const i18nKey = PUBLISHER_CLASS_I18N_KEY_MAP[value];
  if (!i18nKey) {
    return value;
  }
  return formatMessage({ id: i18nKey });
};
